import * as React from "react";
const SvgFiRrSquareX = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-x_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM17.769 6.641 13.303 12l4.466 5.359a1 1 0 1 1-1.538 1.281L12 13.562 7.769 18.64a1.002 1.002 0 0 1-1.41.128 1 1 0 0 1-.128-1.409L10.697 12 6.231 6.641A1 1 0 0 1 7.768 5.36l4.231 5.078L16.23 5.36a1.001 1.001 0 0 1 1.537 1.281z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-x_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareX;
